/**
 * Measurement-only entry for the static Products index.
 *
 * This intentionally imports no island registry, Preact, form code, catalog
 * UI, or homepage behavior. It closes the one gap in the visit walk—Products
 * was previously invisible—using the same first-party visit and event modules
 * as the full website bundle.
 */

import { trackPageView } from "./zentos_web/measure.js";
import { recordVisit } from "./zentos_web/visit.js";

export function bootMeasurement() {
	try {
		recordVisit();
	} catch (err) {
		console.warn("[zentos-web] the visit could not be recorded", err);
	}
	trackPageView();
}

if (typeof document !== "undefined") {
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", bootMeasurement, { once: true });
	} else {
		bootMeasurement();
	}
}
